import React, { useRef, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Text } from '@components/typography';
import { hotelRoomBlocksPageData } from '@data-ts/pages/hotel-room-blocks';
import {
  StyledSection,
  TextContentWrapper,
  StyledTitleText,
  StyledContentText,
  StyledReadMore,
  ItemWrapper,
} from './TextContenBlock.styles';

const textContentBlock = hotelRoomBlocksPageData.textContentBlock;

export const TextContentBlock = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const contentWrapperRef = useRef<HTMLDivElement>(null);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
    if (isExpanded && contentWrapperRef?.current) {
      contentWrapperRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <StyledSection as="section" id="HotelRoomBlocks_TextContent">
      <TextContentWrapper isExpanded={isExpanded} ref={contentWrapperRef}>
        {textContentBlock?.data?.map(({ title, content }, index) => (
          <ItemWrapper key={index}>
            <StyledTitleText color="neutra6" variant="dek20" tagName="p" paddingBottom={4}>
              {ReactHtmlParser(title)}
            </StyledTitleText>
            <StyledContentText color="neutra5" variant="dek15" tagName="p">
              {ReactHtmlParser(content)}
            </StyledContentText>
          </ItemWrapper>
        ))}
      </TextContentWrapper>
      <StyledReadMore role="button" onClick={toggleExpanded}>
        <Text variant="dek15" style={{ fontWeight: 'bold' }} color="actionPurple3" tagName="span">
          {isExpanded ? textContentBlock.seeLess : textContentBlock.readMore}
        </Text>
      </StyledReadMore>
    </StyledSection>
  );
};
